// @core/api/endpoints/notifications/delete_contact.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/notifications';

/**
 * Delete contact
 * Permanently deletes a contact entry. Notifications will no longer be delivered to this contact.
 */
export async function DeleteContact(
  contact_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/contacts/:contact_id`;
  requestPath = requestPath.replace(':contact_id', encodeURIComponent(contact_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
